import axios from 'axios';
import * as Sentry from "@sentry/react";
import { getAuth } from "firebase/auth";


const api = axios.create({
    baseURL: import.meta.env.VITE_URL_API,
    //withCredentials: true, // Removed cookie-based authentication
});


let timezone = "America/Toronto";
try { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (ex) { }
api.interceptors.request.use(async config => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
        const token = await user.getIdToken();
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['x-timezone'] = timezone;
    return config;
});


api.interceptors.response.use(
    response => response,
    error => {
        // Handle 401 Unauthorized error
        if (error?.response?.status === 401) {
            // Optional: auto logout or refresh token
            const auth = getAuth();
            auth.signOut(); // Sign out the user if unauthorized
            return Promise.reject(error);
        }

        // Sentry.captureException
        Sentry.withScope(scope => {
            if (error.config?.url) {
                scope.setExtra("request.url", error?.config?.url);
            }
            if (error.response) {
                scope.setExtra("response.status", error?.response?.status);
                scope.setExtra("response.data", error?.response?.data);
            }
            scope.setTag("http.client", "axios");
            Sentry.captureException(error);
        });

        return Promise.reject(error);
    }
);

export const apiGet = (url) => api.get(url)
export const apiPost = (url, data) => api.post(url, data)
export const apiPut = (url, data) => api.put(url, data)
export const apiDelete = (url) => api.delete(url)

export default api;